module.exports = __webpack_public_path__ + "img/skype.440a1249.svg";